<template>
  <div class="card" v-show="currentCardId == 'reasonNew'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自己PRを入力</h2>
        <p>{{ reasonLabel }}</p>
      </div>
      <div class="add-item">
        <el-button type="success" @click="exampleVisible = true"
          >例文から追加</el-button
        >
      </div>
      <div class="card-content">
        <NewRirekishoExampleSentenceDialog
          :value="exampleVisible"
          name="reason-dialog"
          :items="reasonExamples"
          show-overwrite-warning
          @input="exampleVisible = $event"
          @select="onSelectExample"
        />
        <el-input
          type="textarea"
          v-model="formatData.reasonNew"
          v-proofread
          :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
        />
        <div class="attention-limit character" v-if="previewErrors.reasonNew">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
        <template v-if="showPrimeUpsell">
          <div class="prime-tips-btn-wrap">
            <button class="prime-tips-btn" @click="primeVisible = true">
              👑 AIで自己PRを何度も作成
            </button>
          </div>
          <RirekishoPrimeUpsellDialog
            :value="primeVisible"
            name="prime-reasonnew-modal"
            @input="primeVisible = $event"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import RirekishoPrimeUpsellDialog from '@/components/format-edit/rirekisho/RirekishoPrimeUpsellDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'

const reasonLabel =
  '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！'

const props = withDefaults(
  defineProps<{
    currentCardId?: string
    exampleSentences?: RirekishoExampleSentences
    textareaMinRows: number
    previewErrors: Record<string, string>
    exampleKey?: 'reason' | 'promotion'
    showPrimeUpsell?: boolean
  }>(),
  {
    exampleKey: 'reason',
    showPrimeUpsell: true
  }
)

const formatData = useRirekishoFormatData()
const exampleVisible = ref(false)
const primeVisible = ref(false)

const reasonExamples = computed(() => {
  if (props.exampleKey === 'promotion') {
    return props.exampleSentences?.promotion || []
  }
  return props.exampleSentences?.reason || []
})

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.reasonNew += item.description.replace(/<br>/gi, '\n') + '\n'
}
</script>

<style lang="scss" scoped>
.prime-tips-btn-wrap {
  text-align: center;
  margin: 20px 0 10px;
}

.prime-tips-btn {
  display: inline-block;
  max-width: 100%;
  background: #ff8c00;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  border: none;
  border-radius: 30px;
  padding: 10px 24px;
  white-space: normal;
  line-height: 1.4;
  cursor: pointer;
}
</style>
